<div
  class="position-absolute bottom-1 end-5 z-3 z-3 cursor-pointer fs-xs align-items-center text-deactivated"
>
  Rollout date: {{ rolloutDate() }}
</div>
